import axios from 'axios';
import { NaptarBejegyzesDto } from './naptarServiceTypes';
import { getApiErrorMessage } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

class CegesAutoService {
  async getByDateRange(startDate: string, endDate: string): Promise<NaptarBejegyzesDto[]> {
    try {
      const response = await api.get<NaptarBejegyzesDto[]>(`/cegesauto/date-range?startDate=${startDate}&endDate=${endDate}`);
      return response.data;
    } catch (error) {
      throw new Error(getApiErrorMessage(error, 'Nem sikerült betölteni a céges autó bejegyzéseket.'));
    }
  }

  async create(data: Partial<NaptarBejegyzesDto>): Promise<NaptarBejegyzesDto> {
    try {
      const response = await api.post<NaptarBejegyzesDto>('/cegesauto', data);
      return response.data;
    } catch (error) {
      throw new Error(getApiErrorMessage(error, 'Nem sikerült létrehozni a céges autó bejegyzést.'));
    }
  }

  async update(id: number, data: Partial<NaptarBejegyzesDto>): Promise<NaptarBejegyzesDto> {
    try {
      const response = await api.put<NaptarBejegyzesDto>(`/cegesauto/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(getApiErrorMessage(error, 'Nem sikerült frissíteni a céges autó bejegyzést.'));
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await api.delete(`/cegesauto/${id}`);
    } catch (error) {
      throw new Error(getApiErrorMessage(error, 'Nem sikerült törölni a céges autó bejegyzést.'));
    }
  }
}

export const cegesAutoService = new CegesAutoService();
